export enum Currency {
    OCT = 'oct',
    APT = 'apt',
    ETH = 'eth',
    WEI = 'wei',
    USD = 'usd',
}

export type CurrencyConversionRate = {
    [currency in Currency]?: {
        [Currency.USD]: number;
    };
};
